import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor() { }

  isObj(val) {
    return typeof val === 'object' && val !== null && !Array.isArray(val)
  }
  isObjOrArray(val) {
    return (typeof val === 'object' && val !== null && !Array.isArray(val)) || Array.isArray(val)
  }
}
